// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a0d1b85","453":"605462d3","455":"58c8da14"}[chunkId] + ".chunk.js";
};